export const COLOR_PRIMARY = 'rgba(125,191,220,1)'//'rgba(12, 106, 166, 1)'
export const COLOR_SETTINGS = COLOR_PRIMARY
export const COLOR_CLINICS = COLOR_PRIMARY
export const COLOR_PATIENTS = 'rgba(157, 195, 0, 1)'
export const COLOR_SECONDARY = 'rgba(185,48,132,1)'
export const COLOR_REPORTS = COLOR_PRIMARY
export const COLOR_RESULTS = COLOR_PRIMARY
export const COLOR_MATCHING = 'rgba(106, 106, 106, 1)'
export const COLOR_MENU_PRIMARY = 'rgba(130, 130, 130, 1)'
export const COLOR_LOGIN = 'rgba(29,55,100,1)'